import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';

export const ListContainer = styled(Paper)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    height: 'calc(100% - 52px)',
    overflowY: 'auto'
  }
}));

export const StyledList = styled(List)({
  width: '100%'
});

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  paddingRight: theme.spacing(),
  paddingLeft: theme.spacing(6),
  '&:hover': {
    backgroundColor: theme.palette.grey['200']
  }
}));

export const HeaderListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing()
}));

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: theme.spacing(5)
}));

export const HeaderListItemText = styled(ListItemText, {
  shouldForwardProp: prop => prop !== 'tinted'
})(({ tinted }) => ({
  textTransform: 'uppercase',
  ...(tinted && { color: '#828282' })
}));

export const DeviceListItemText = styled(ListItemText, {
  shouldForwardProp: prop => prop !== 'tinted'
})(({ tinted }) => ({
  overflow: 'hidden',
  marginRight: 4,
  ...(tinted && { color: '#828282' })
}));

export const StyledListSubheader = styled(ListSubheader)({
  backgroundColor: '#D9D9D9',
  lineHeight: '32px',
  paddingLeft: 28,
  fontWeight: 400,
  position: 'relative'
});

export const StyledListItemSecondaryAction = styled(ListItemSecondaryAction)(({ theme }) => ({
  right: 'auto',
  left: theme.spacing(2)
}));

export const IconCnt = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexGrow: 100,
  maxWidth: 85
});
export const IconCntLeft = styled('div')({
  display: 'flex',
  alignItems: 'center',
  '& > * + *': {
    marginLeft: 4
  }
});

export const VerticalIconCnt = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});
